export default __webpack_public_path__ + "static/front-bb5eb8039963399d07c6e081e7862600.jpg";